module.exports = __webpack_public_path__ + "img/mono-rounded.d35eca5f.svg";